module.exports = __webpack_public_path__ + "img/nl.f685765a.svg";